'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, InputGroupAddon, InputGroupButton, Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui/components/start';
import { TriangleAlert } from '@repo/ui/icons';
import { usePhoneInput } from './context';
export function PhoneInputValidationIndicator() {
  const $ = _c(13);
  const {
    state
  } = usePhoneInput();
  const {
    disabled,
    layout,
    validationMessage
  } = state;
  if (disabled || !validationMessage) {
    return null;
  }
  let t0;
  if ($[0] !== layout || $[1] !== validationMessage) {
    t0 = layout === "input-group" ? <InputGroupButton aria-label={validationMessage} type="button" /> : <Button aria-label={validationMessage} className="px-2" type="button" variant="ghost" />;
    $[0] = layout;
    $[1] = validationMessage;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TriangleAlert className="size-3.5 text-destructive" />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0) {
    t2 = <TooltipTrigger render={t0}>{t1}</TooltipTrigger>;
    $[4] = t0;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== validationMessage) {
    t3 = <TooltipContent align="end">{validationMessage}</TooltipContent>;
    $[6] = validationMessage;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <Tooltip>{t2}{t3}</Tooltip>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const indicator = t4;
  if (layout === "input-group") {
    let t5;
    if ($[11] !== indicator) {
      t5 = <InputGroupAddon align="inline-end">{indicator}</InputGroupAddon>;
      $[11] = indicator;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    return t5;
  }
  return indicator;
}